import React from "react";
import { Check as CheckIcon } from "@mui/icons-material";

import Button, { ButtonTypes } from "../../../../../../components/Button";
import { LogPaymentButtonProps } from "./types";
import { ButtonWrapper } from "./styles";

export const LogPaymentButton: React.FC<LogPaymentButtonProps> = ({
  onLogPayment,
}) => (
  <ButtonWrapper>
    <Button
      type={ButtonTypes.primary}
      size="large"
      buttonType="button"
      onClick={onLogPayment}
    >
      <CheckIcon />
      Log this payment
    </Button>
  </ButtonWrapper>
);
